import { createSlice } from "@reduxjs/toolkit";

// Helper function to create initial tab state for COCA Annual second table
const createInitialSecondTabState = () => ({
    data: [],
    loading: false,
    error: false,
    selectedRows: [],
    lastUpdated: null,
    // Search functionality state
    searchData: {
        MSIID: '',
        Carrier: '',
        Account: '',
        Group: '',
        MemberID: ''
    },
    isSearchClicked: false,
    showAll: false,
    inputError: {
        MSIID: false,
        Carrier: false,
        Account: false,
        Group: false,
        MemberID: false
    },
    // COCA Annual specific states
    jobStatus: null,
    summaryData: null
});

// Initial state with 3 COCA Annual tabs for second table
const initialState = {
    tabs: Array.from({ length: 3 }, () => createInitialSecondTabState())
};

const CocaAnnualTabSecondTableSlice = createSlice({
    name: 'cocaAnnualTabSecondTable',
    initialState,
    reducers: {
        // Set selected rows for specific tab
        setSelectedRows: (state, action) => {
            const { tabIndex, selectedRows } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].selectedRows = selectedRows;
            }
        },

        // Clear second table data for specific tab
        clearSecondTableData: (state, action) => {
            const { tabIndex } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].data = [];
                state.tabs[tabIndex].selectedRows = [];
                state.tabs[tabIndex].error = false;
                state.tabs[tabIndex].lastUpdated = null;
            }
        },

        // Update search data for specific tab
        updateSearchData: (state, action) => {
            const { tabIndex, field, value } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].searchData[field] = value;
                // Clear input error when user starts typing
                if (state.tabs[tabIndex].inputError[field]) {
                    state.tabs[tabIndex].inputError[field] = false;
                }
            }
        },

        // Reset search data for specific tab
        resetSearchData: (state, action) => {
            const { tabIndex } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].searchData = {
                    MSIID: '',
                    Carrier: '',
                    Account: '',
                    Group: '',
                    MemberID: ''
                };
                state.tabs[tabIndex].inputError = {
                    MSIID: false,
                    Carrier: false,
                    Account: false,
                    Group: false,
                    MemberID: false
                };
            }
        },

        // Set show all mode for specific tab
        setShowAll: (state, action) => {
            const { tabIndex, showAll } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].showAll = showAll;
            }
        },

        // Set input validation errors
        setInputError: (state, action) => {
            const { tabIndex, field, hasError } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].inputError[field] = hasError;
            }
        }
    },
});

// Export actions
export const {
    setSelectedRows,
    clearSecondTableData,
    updateSearchData,
    resetSearchData,
    setShowAll,
    setInputError
} = CocaAnnualTabSecondTableSlice.actions;

export default CocaAnnualTabSecondTableSlice.reducer;
